import Vue from 'vue'
import Router from 'vue-router'
import store from '@/store'

import { UI_SET_ACTIONS } from '@/store/actions/ui'
import { USER_REQUEST } from '@/store/actions/user'
import { ORG_PROFILE_REQUEST } from '@/store/actions/org'

Vue.use(Router)

const router = new Router({
  routes: [
    { // Admin
      path: '/admin',
      name: 'Администрирование системы',
      meta: {
        requiresAuth: true
      },
      component: () => import(/* webpackChunkName: "admin" */ '@/views/admin/adminIndex.vue'),
      children: [
        {
          path: '/admin/orgStructure',
          name: 'Структура организации',
          component: () => import(/* webpackChunkName: "admin" */ '@/views/admin/org/orgStructureIndex.vue'),
          meta: {
            requiresAuth: true
          }
        }
      ]
    },
    { // Portal
      path: '/portal',
      name: 'Портал пользователей',
      meta: {
        requiresAuth: true
      },
      component: () => import(/* webpackChunkName: "portal" */ '@/views/orgUser/orgUserIndex.vue'),
      children: [
        {
          path: '/portal/userProfile',
          name: 'Профиль сотрудника',
          component: () => import(/* webpackChunkName: "portal" */ '@/views/orgUser/subpages/orgUserProfile.vue'),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: '/portal/addrbook',
          name: 'Справочник сотрудников',
          component: () => import(/* webpackChunkName: "portal" */ '@/views/orgUser/subpages/addrbookIndex.vue'),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: '/portal/claims',
          name: 'Поддержка',
          component: () => import(/* webpackChunkName: "portal" */ '@/views/orgUser/subpages/claimsIndex.vue'),
          meta: {
            requiresAuth: true
          }
        }
      ]
    },
    { // Project Management
      path: '/projects',
      name: 'Управление проектами',
      component: () => import(/* webpackChunkName: "project" */ '@/views/projects/projectsIndex.vue'),
      meta: {
        requiresAuth: true
      },
      children: [
        {
          path: '/projects/myprojects',
          name: 'Мои проекты',
          component: () => import(/* webpackChunkName: "project" */ '@/views/projects/subpages/myProjects.vue'),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: '/projects/project',
          name: 'Редактор задачи',
          props: (route) => ({ reqid: route.query.reqid }),
          component: () => import(/* webpackChunkName: "project" */ '@/views/projects/subpages/project/projectEditor.vue'),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: '/projects/mycalcs',
          name: 'Мои расчёты',
          component: () => import(/* webpackChunkName: "project" */ '@/views/projects/subpages/myCalculations.vue'),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: '/projects/calc',
          name: 'Редактор расчёта',
          component: () => import(/* webpackChunkName: "project" */ '@/views/projects/subpages/calc/calcEditor.vue'),
          meta: {
            requiresAuth: true
          }
        }
      ]
    },
    { // References
      path: '/references',
      name: 'Системные справочники',
      component: () => import(/* webpackChunkName: "sysReferences" */ '@/views/references/refIndex.vue'),
      meta: {
        requiresAuth: true
      },
      children: [
        {
          path: '/references/list',
          name: 'Все системные справочники',
          component: () => import(/* webpackChunkName: "sysReferences" */ '@/components/modules/references/refList'),
          props: false,
          meta: {
            requiresAuth: true
          }
        },
        {
          path: '/references/list/:reference',
          component: () => import(/* webpackChunkName: "sysReferences" */ '@/views/references/subpages/refView'),
          props: true,
          meta: {
            requiresAuth: true
          }
        }
      ]
    },
    {
      path: '/passreminder',
      name: 'Password reminder',
      meta: {
        requiresAuth: false
      },
      component: () => import(/* webpackChunkName: "general" */ '@/components/login/passReminder.vue')
    },
    {
      path: '/passrecovery',
      name: 'Password recovery',
      props: (route) => ({ reqid: route.query.reqid }),
      meta: {
        requiresAuth: false
      },
      component: () => import(/* webpackChunkName: "general" */ '@/views/orgUser/subpages/passrecover.vue')
    },
    {
      path: '/login',
      name: 'Login',
      meta: {
        requiresAuth: false
      },
      component: () => import(/* webpackChunkName: "general" */ '@/components/login')
    },
    {
      path: '*',
      name: '404PageGeneral',
      meta: {
        ru_caption: 'Раздел не найден',
        area_id: -1,
        subarea_id: 999,
        requiresAuth: false
      },
      component: () => import(/* webpackChunkName: "general" */ '@/components/404page.vue')
    }

  ]
})

router.beforeEach((to, from, next) => {
  // console.log('Router requested for route: ', to)
  if (to.matched.some(record => record.meta.requiresAuth)) {
    // console.log('This route requires authentication')
    if (store.getters.isAuthenticated) {
      // console.log('User authenticated, procceding')
      store.dispatch(USER_REQUEST)
      store.dispatch(ORG_PROFILE_REQUEST)
      store.dispatch(UI_SET_ACTIONS, [])
      next()
      return
    }
    if (to.name !== 'Login') {
      // console.log('Redirect to login')
      next('/login')
    } else {
      // console.log('Alter Redirect to login')
      next()
    }
  } else {
    // console.log('This route requires NOT auth')
    next()
  }
})

export default router
